import { DatePicker } from "@progress/kendo-react-dateinputs";
import dayjs from "dayjs";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";

function ETADTXDDatePicker(props) {
  const { dataItem } = props;
  const [inEdit, setInEdit] = useState(false);
  const [date, setDate] = useState(dataItem["ETA_DT_XD"]);

  useEffect(() => {
    console.log("---------------------- Date props -----------------------");
    console.log(props);
    if ("inEdit" in props["dataItem"]) {
      if (props["dataItem"]["inEdit"] === true) {
        setInEdit(true);
      }
    }
  }, [props, dataItem]);

  const handleChange = (e) => {
    setDate(e.target.value);
  };

  const setDateOnBlur = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e,
        value: date,
      });
    }
  };

  return (
    <td>
      {inEdit === true ? (
        <DatePicker
          onChange={handleChange}
          value={date}
          onBlur={setDateOnBlur}
          format="MM/dd/yyyy"
        ></DatePicker>
      ) : props["dataItem"]["ETA_DT_XD"] !== "" ? (
        dayjs(props["dataItem"]["ETA_DT_XD"]).format("MM/DD/YYYY")
      ) : (
        ""
      )}
      {/* {JSON.stringify(props['dataItem'], null, 2)} */}
    </td>
  );
}

export default ETADTXDDatePicker;
